<template>
    <v-card class="card--shadow">
        <v-card-title class="purple accent-4">
            <div class="subtitle-1 white--text">CI/HE Edit Form</div>
        </v-card-title>
        <v-card-text class="pt-4">
            <form-require-noti />
            <v-row>
            <v-col lg="6">
                <label>Date <require-sign /></label>
                <date-picker
                @clearDate="ciData.date = null"
                :validationMsg="handleFieldErrors($v.ciData.date)"
                :date="ciData.date"
                v-model="ciData.date"
                :min="minDate"
                :max="maxDate"
                />
            </v-col>
            <v-col lg="6">
                <label>Screening Person <require-sign /></label>
                <v-select
                :items="[
                    { id: '1', text: 'Volunteer' },
                    { id: '2', text: 'FO' },
                ]"
                v-model="ciData.screening_person"
                :error-messages="handleFieldErrors($v.ciData.screening_person)"
                item-text="text"
                item-value="id"
                dense
                outlined
                ></v-select>
            </v-col>
            </v-row>
            <v-row v-if="ciData.screening_person == 1">
              <v-col lg="6">
                <label>Volunteers<require-sign /></label>
                <v-select
                  :items="volunteers"
                  v-model="ciData.volunteer_id"
                  item-value="id"
                  item-text="name"
                  :value-comparator="volunteerSelectComparator"
                  :error-messages="handleFieldErrors($v.ciData.volunteer_id)"
                  dense
                  outlined
                >
                  <template v-slot:item="{ item }">
                    <span>{{ item.name == null ? '' : item.name }} / {{ item.code }}</span>
                  </template>
                  <template v-slot:selection="{ item }">
                    <span>{{ item.name == null ? '' : item.name }} / {{ item.code }}</span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="6">
                <label>Symptom Screening <require-sign /></label>
    
                <v-radio-group v-model="ciData.symptom_screening" row >
                    <v-radio label="Yes" value="2"></v-radio>
                    <v-radio label="No" value="1"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col lg="6">
                <label>Refer <require-sign /></label>
    
                <v-radio-group v-model="ciData.refer" row >
                    <v-radio label="Yes" value="2"></v-radio>
                    <v-radio label="No" value="1"></v-radio>
                </v-radio-group>
            </v-col>
            </v-row>
            <v-card-actions >
            <v-spacer></v-spacer>
           
            <v-btn @click.prevent="emitData" :loading="loading" class="form-btn">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
            </v-btn>
        </v-card-actions>
        </v-card-text>
  
    </v-card>
  </template>
  
  <script>
  import { required } from "vuelidate/lib/validators";
  import { ValidationMixin } from "../../mixins/ValidationMixin";
  import { limitDateMixin } from "../../mixins/limitDateMixin";
  import { mapState, mapActions } from "vuex";
  import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
  import RequireSign from "@/components/notification/RequireSign.vue";
  import DatePicker from "@/components/common/DatePicker.vue";
  export default {
    components: { RequireSign, FormRequireNoti, DatePicker },
    mixins: [ValidationMixin, limitDateMixin],
    props: {
      ciData: {
        type: Object,
        default: () => {
          return {
            screening_person: null,
            date: null,
            symptom_screening:null,
            presumptive_id:null,
            screening_township_id:null,
            township_id:null,
            refer:null,
            volunteer_id: null,
        };
        },
      },
    },
    beforeMount() {
    this.ciData.date = !this.ciData.date ? this.minDate : this.ciData.date;
  },
    validations() {
      return {
        ciData: {
          date: { required },
          screening_person: { required },
          symptom_screening: { required },
          screening_township_id:{required},
          refer:{required},
          volunteer_id: {
            required() {
              return this.ciData.screening_person == 1
                ? required(this.ciData.volunteer_id)
                : true;
            },
          },
        },
      };
    },
 
    methods: {
      ...mapActions("Township", ["getAllTownships"]),

      volunteerSelectComparator(a, b) {
        if (a === b) return true;
        if (a == null || b == null || a === "" || b === "") return false;
        return String(a) === String(b);
      },

      /** Align API volunteer_id type with list items so v-select shows selection. */
      syncVolunteerIdWithItems(list) {
        if (!Array.isArray(list) || !list.length) return;
        const raw = this.ciData.volunteer_id;
        if (raw == null || raw === "") return;
        const match = list.find((v) => String(v.id) === String(raw));
        if (match) this.ciData.volunteer_id = match.id;
      },

      emitData() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let data = {
            id: this.ciData.id,
            date: this.ciData.date,
            screening_person: this.ciData.screening_person,
            symptom_screening: this.ciData.symptom_screening,
            screening_township_id: this.ciData.screening_township_id,
            township_id: this.$route.params.township_id,
            refer:this.ciData.refer,
            volunteer_id: this.ciData.volunteer_id,
          };
          this.$emit("emitData", data);
        }
      },
    },
    computed: {
      ...mapState("Loading", ["loading"]),
      ...mapState("Volunteer", ["volunteers"]),
      ...mapState("HE", ["townshipVolunteers"]),
      ...mapState("Admin", ["admin"]),
      ...mapState("InfoData", ["mdrTbRegs", "typeOfTBOpt"]),
      ...mapState("Township", [ "townships"]),
    },
    
    watch: {
      volunteers: {
        handler(val) {
          this.syncVolunteerIdWithItems(val);
        },
        immediate: true,
      },
      "ciData.volunteer_id"() {
        this.syncVolunteerIdWithItems(this.volunteers);
      },
      "ciData.screening_person"(val) {
        if (val != 1 && val != "1") {
          this.ciData.volunteer_id = null;
        }
      },
    },
    created() {
      this.$store.dispatch(
        "Volunteer/getVolunteerByTwnId",
        this.$route.params.township_id
      );
      this.getAllTownships();
    },
  };
  </script>
  
  <style scoped></style>
  